import * as yup from "yup";

const solicitudVacantesCerrarValidacionEsquema = (tienePermisoSolicitudOperativa) =>
  yup.object().shape({
    tipoOperadorId: tienePermisoSolicitudOperativa
      ? yup.number().typeError("tipoOperadorId es requerido")
          .required("tipoOperadorId es requerido")
          .min(1, "tipoOperadorId es requerido")
      : yup.number().nullable(),

    unidadId: tienePermisoSolicitudOperativa
      ? yup.number().typeError("unidadId es requerido")
          .required("unidadId es requerido")
          .moreThan(0, "unidadId es requerido") 
      : yup.number().nullable(),

    empleadoId: tienePermisoSolicitudOperativa
      ? yup.number().typeError("empleadoId es requerido")
          .required("empleadoId es requerido")
          .min(1, "empleadoId es requerido")
      : yup.number().nullable(),
  });

export default solicitudVacantesCerrarValidacionEsquema;
